import React, { useState, useEffect } from 'react';
import ReactECharts from 'echarts-for-react';

import { commonOptions } from 'data/eco-environmental-survey';
import { GRAPH_HEIGHT, GRAPH_COLOR } from 'data/common';
import { BE_URL } from 'utils/config';

function BarLineGraph() {
  const [loading, setLoading] = useState(true);
  const [xAxis, setXAxis] = useState([]);
  const [series, setSeries] = useState({ bar: [], line: [] });

  const height = GRAPH_HEIGHT.default;
  const isFetchingSeries = series.bar.length === 0 || series.line.length === 0;

  useEffect(() => {
    async function fetchData() {
      try {
        const res = await fetch(`${BE_URL}/api/oyster-stats/village/`);
        if (!res.ok) throw new Error('Network response was not ok');
        const json = await res.json();
        const rows = Array.isArray(json) ? json : [];

        const years = rows.map((r) => String(r['年份']));

        const toNumber = (v) => Number(String(v).replace(/,/g, ''));
        const barData = rows.map((r) => toNumber(r['設施（組）']));
        const lineData = rows.map((r) => toNumber(r['養殖（戶）']));

        setXAxis(years);
        setSeries({ bar: barData, line: lineData });
      } catch (error) {
        console.error('載入 OysterFarmingStats 失敗:', error);
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, []);

  const option = {
    ...commonOptions,
    color: GRAPH_COLOR.legend.double,
    title: { text: `芳苑鄉歷年牡蠣養殖(平掛式)` },
    dataZoom: { show: true },
    tooltip: {
      trigger: 'axis',
      backgroundColor: GRAPH_COLOR.tooltip.background.dark,
      axisPointer: { type: 'shadow', label: { show: true } },
    },
    legend: { top: 'auto', left: 'center', bottom: '12.5%', itemGap: 5 },
    grid: { width: '80%', left: '12.5%', height: '60%' },
    xAxis: { type: 'category', boundaryGap: true, data: xAxis },
    yAxis: { type: 'value' },
    series: [
      { data: series.bar, type: 'bar', name: '設施（組）' },
      { data: series.line, type: 'line', name: '養殖（戶）' },
    ],
  };

  return (
    <div className="col-12">
      {loading && <p>資料載入中...</p>}

      {!loading && isFetchingSeries && <p>目前沒有資料可顯示</p>}

      {!loading && !isFetchingSeries && (
        <ReactECharts
          option={option}
          notMerge={true}
          lazyUpdate={true}
          opts={{ renderer: 'canvas', height: `${height}` }}
          style={{ height }}
        />
      )}
    </div>
  );
}

export default BarLineGraph;
